import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import { SDialog } from '@avalara/skylab-sdk/react';

const log = new Logger('BOX_VALUE_VALIDATION_MODAL', LOG_LEVELS.DEBUG);
const autoAdjustmentTextToCompare = 'Please make the necessary corrections before filing.';

class BoxValueValidationModal extends Component {
    constructor(props) {
        super(props);
        // Track if Yes was clicked to prevent onS-dismiss from triggering close
        this.yesClicked = false;
    }

    // Reset body overflow to ensure page scrollability is restored
    resetBodyOverflow() {
        document.body.style.overflow = '';
    }

    onCloseClick() {
        // Only call close handler if Yes wasn't clicked
        // (SDialog fires onS-dismiss when it closes, even after Yes)
        if (this.yesClicked) {
            this.yesClicked = false; // Reset for next time
            return;
        }
        if (typeof this.props.onCloseClickHandler === 'function')
            this.props.onCloseClickHandler();
        this.resetBodyOverflow();
    }

    onYesClick() {
        if (typeof this.props.onYesClickHandler === 'function')
            this.props.onYesClickHandler();
        // Set flag to prevent onS-dismiss from triggering cancel
        this.yesClicked = true;
        this.resetBodyOverflow();
    }

    componentDidUpdate(prevProps) {
        // Reset body overflow when modal closes to prevent page from being stuck
        if (prevProps.isModalPopupOpen && !this.props.isModalPopupOpen) {
            this.resetBodyOverflow();
        }
    }

    componentWillUnmount() {
        // Ensure body overflow is reset when component unmounts
        this.resetBodyOverflow();
    }

    isAutoCorrectedInfoMode() {
        // Show the informational "Box Value Auto Correction" dialog when:
        // - The backend reported manualCorrectionBoxes (isManualCorrection)
        // - The backend already kicked off an auto-correction (isBoxValueAutoCorrected)
        // The outer onOpenModal guard already ensures warningMessage is non-empty.
        return Boolean(
            this.props.isManualCorrection
            && this.props.isBoxValueAutoCorrected
        );
    }

    renderButtons() {
        if (this.isAutoCorrectedInfoMode()) {
            return (
                <button className="primary" onClick={this.onCloseClick.bind(this)}>
                    <LanguageStringResolver string='vatBoxValidation_close_button' />
                </button>
            );
        }
        if (this.props.featureFlag?.EnableAutoAdjustments && this.props.isManualCorrection) {
            return (
                <div>

                    <button className="primary" onClick={this.onYesClick.bind(this)}>
                        <LanguageStringResolver string='vatBoxValidation_yes_button' />
                    </button>
                    <button className="secondary" onClick={this.onCloseClick.bind(this)}>
                        <LanguageStringResolver string='vatBoxValidation_no_button' />
                    </button>
                </div>
            );
        } else {
            return (
                <button className="primary" onClick={this.onCloseClick.bind(this)}>
                    <LanguageStringResolver string='vatBoxValidation_close_button' />
                </button>
            );
        }
    }

    render() {
        const isAutoCorrectedInfo = this.isAutoCorrectedInfoMode();
        const isAutoAdjust = (this.props.featureFlag?.EnableAutoAdjustments && this.props.isManualCorrection);
        const titleStringKey = isAutoCorrectedInfo ? 'vatBoxAutoCorrection_Title' : 'vatBoxValidation_Title';
        return (
            <div>
                <SDialog
                    open={this.props.isModalPopupOpen}
                    onS-dismiss={this.onCloseClick.bind(this)}
                    data-testid="box-value-validation-modal"
                >
                    <div slot="header">
                        <h1><LanguageStringResolver string={titleStringKey} /></h1>
                    </div>
                    <div slot="body">
                        {isAutoCorrectedInfo
                            ? (<p className="mb20 mt5"><LanguageStringResolver string="vatBoxAutoCorrection_Message" /></p>)
                            : (
                                <>
                                    <p className="mb0 mt5"><LanguageStringResolver string="vatBoxValidation_Header" /></p>
                                    {!isAutoAdjust &&
                                        <p className="mb20 mt0"><LanguageStringResolver string="vatBoxValidation_SubHeader" /></p>
                                    }
                                    {isAutoAdjust &&
                                        <div className="mt20">
                                            <span style={{
                                                background: 'black',
                                                color: 'white',
                                                padding: '2px 10px'
                                            }}><LanguageStringResolver string='vatBox_AutoAdjustment_Question' /></span>
                                            <p className="mb0 mt0" style={{fontStyle:'italic'}}><LanguageStringResolver string='vatBox_AutoAdjustment_Yes_description' /></p>
                                            <p className="mb10 mt0" style={{fontStyle:'italic'}}><LanguageStringResolver string='vatBox_AutoAdjustment_No_description' /></p>
                                        </div>
                                    }
                                </>
                            )
                        }
                        <p><span><textarea
                            type="text"
                            name="warningMessage"
                            className="mt10 full-width"
                            value={this.props.modalMessage.join('\n')}
                            rows={5}
                            readOnly
                        >
                        </textarea></span></p>
                    </div>
                    <div slot="footer">
                        {this.renderButtons()}
                    </div>
                </SDialog>
            </div>
        );
    }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        featureFlag: state.featureFlag?.data
    };
}

BoxValueValidationModal.defaultProps = {
    modalMessage: [],
    onCloseClickHandler: () => { },
    isModalPopupOpen: false,
    isManualCorrection: false,
    isBoxValueAutoCorrected: false
};
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(BoxValueValidationModal);
